import type { FC, ReactNode } from 'react'
import type { LucideIcon } from 'lucide-react'

import {
    AtSign,
    Bitcoin,
    Briefcase,
    Building2,
    Car,
    Dumbbell,
    KeyRound,
    Package,
    Palette,
    Shirt,
    Smartphone,
    Sofa,
    Tag,
    Ticket,
    Wrench
} from 'lucide-react'

import { cn } from '@/lib/utils'

/**
 * Explicit map rather than a dynamic lookup, so only the icons actually in
 * use are bundled and an unknown name degrades to a neutral tag instead of
 * rendering nothing.
 */
const ICONS: Record<string, LucideIcon> = {
    AtSign,
    Bitcoin,
    Briefcase,
    Building2,
    Car,
    Dumbbell,
    KeyRound,
    Package,
    Palette,
    Shirt,
    Smartphone,
    Sofa,
    Tag,
    Ticket,
    Wrench
}

export const CATEGORY_ICON_NAMES = Object.keys(ICONS)

interface CategoryIconProps {
    name: string | null | undefined
    className?: string
}

export const CategoryIcon: FC<CategoryIconProps> = ({ name, className }): ReactNode => {
    const Icon = (name && ICONS[name]) || Tag

    return <Icon className={cn('size-5', className)} aria-hidden='true' />
}
